import Vue from 'vue'
import VueRouter from 'vue-router'
// import loadSudoku from '@/assets/js/loadSudoku.js'
// import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'default',
    redirect: '/signIn'
  },
  {
    path: '/signIn',
    name: 'SignInPage',
    component: () => import('../views/SingInPage.vue')
    // beforeEnter: (to, from, next) => {
    //	// ...这样定义的守卫是该路由独享的，只有进入该路由时才会执行这个守卫。
    // }
  },
  {
    path: '/create',
    name: 'CreateAccountPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/CreateAccountPage.vue')
  },
  {
    path: '/forget',
    name: 'ForgetPswPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ForgetPswPage.vue')
  },
  {
    path: '/verify',
    name: 'VerificationPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/VerificationPage.vue')
  },
  {
    path: '/register',
    name: 'RegisterPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/RegisterPage.vue')
  },
  {
    path: '/qrcode',
    name: 'WxQrCode',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/WxQrCode.vue')
  },
  {
    path: '/wxlogin',
    name: 'WxLogin',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/WxLogin.vue')
  },
  // {
  // 	path: '/wait',
  // 	name: 'WaitingPage',
  // 	component: () => import(/* webpackChunkName: "about" */ '../views/WaitingPage.vue')
  // },
  {
    path: '/changePsw',
    name: 'ChangePswPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/ChangePswPage.vue')
  },
  {
    path: '/welcome',
    name: 'SuccessPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SuccessPage.vue')
  },
  {
    path: '/signInsso',
    name: 'SingInSSOPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/SingInSSOPage.vue')
  },
  {
    path: '/ssoConfig',
    name: 'SSOConfigPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Configure.vue'),
    children: [
      {
        path: '/',
        redirect: '/configPage'
      },
      {
        path: '/configPage',
        name: 'configPage',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/SSOConfigPage.vue')
      },
      {
        path: '/waitingPage',
        name: 'SSOWaiting',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/SSOWaiting.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
